<script>
  import { onMount } from "svelte";
  import FlagshipProductComponent from "../FlagshipProduct/FlagshipProductComponent.svelte";

  export let nav_item_list;
  export let modifyProductViewHeight;
  export let setAnchor;
</script>

<div class="theme_nav">
  <div class="nav_box">
    {#each nav_item_list as nav_item, i}
      <label for={'nav' + (i + 1)}>
        <div
          class="nav_list"
          on:click={() => modifyProductViewHeight(i)}
          on:click={() => setAnchor()}>
          {nav_item.tab_name}
        </div>
      </label>
    {/each}
  </div>
</div>
